export const Role = {
  ADMIN: "ADMIN",
  PMO: "PMO",
  ACCOUNT_MANAGER: "ACCOUNT_MANAGER",
  DELIVERY_MANAGER: "DELIVERY_MANAGER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  CLIENT_PARTNER: "CLIENT_PARTNER",
}
const ROLE_ALIASES = {
  ADMIN: Role.ADMIN,
  PMO: Role.PMO,
  ACCOUNT_MANAGER: Role.ACCOUNT_MANAGER,
  "ACCOUNT MANAGER": Role.ACCOUNT_MANAGER,
  DELIVERY_MANAGER: Role.DELIVERY_MANAGER,
  "DELIVERY MANAGER": Role.DELIVERY_MANAGER,
  DM: Role.DELIVERY_MANAGER,
  PROJECT_MANAGER: Role.PROJECT_MANAGER,
  "PROJECT MANAGER": Role.PROJECT_MANAGER,
  PM: Role.PROJECT_MANAGER,
  CLIENT_PARTNER: Role.CLIENT_PARTNER,
  "CLIENT PARTNER": Role.CLIENT_PARTNER,
  "CLIENT MANAGER": Role.CLIENT_PARTNER,
  CP: Role.CLIENT_PARTNER,
};
export const normalizeRoleInput = (value) =>
  String(value || "").trim().toUpperCase();

export const parseRole = (value) => {
  const normalized = normalizeRoleInput(value);
  return ROLE_ALIASES[normalized] ?? null;
};

export const getCurrentUserRole = () => {
  const rawRole =
    sessionStorage.getItem("userRole") ||
    sessionStorage.getItem("role") ||
    "";

  return parseRole(rawRole);
};